import { useState } from "react";
import classNames from "classnames";

import Button from "/components/Button";
import TextField from "/components/TextField";

import longArrowUpIcon from "/assets/long-arrow-up.svg";
import longArrowDownIcon from "/assets/long-arrow-down.svg";

export default function TeamForm({
  useStore,
  onRemove,
  onOrderUp,
  onOrderDown,
}) {
  const store = useStore();

  return (
    <div className={classNames("team-form flex-col gap-10", { "team-form--hidden": store.hidden })}>
      <div className="actions-bar actions-bar--nested">
        <div></div>
        <div>
          <div className="actions-bar__order-buttons">
            <Button onClick={onOrderUp} className="btn--icon"><img src={longArrowUpIcon} /></Button>
            <Button onClick={onOrderDown} className="btn--icon"><img src={longArrowDownIcon} /></Button>
          </div>

          <Button
            className="lnk lnk--blue"
            onClick={() => store.setHidden(!store.hidden)}
          >
            {store.hidden ? "Отобразить" : "Скрыть"}
          </Button>
          <Button onClick={onRemove} className="lnk lnk--red">Удалить</Button>
        </div>
      </div>

      <div className="inpt-line">
        <TextField
          placeholder="название команды"
          value={store.name_ru}
          onChange={store.setNameRu}
        />

        <TextField
          placeholder="team name"
          value={store.name_en}
          onChange={store.setNameEn}
        />
      </div>

      {store.members.map((member, index) => (
        <div key={index} className="flex-col gap-3">
          <div className="inpt-line">
            <TextField
              placeholder="фамилия имя"
              value={member.name_ru}
              onChange={(value) => store.setMemberNameRu(index, value)}
            />

            <TextField
              placeholder="full name"
              value={member.name_en}
              onChange={(value) => store.setMemberNameEn(index, value)}
            />
            {(store.members.length > 1) && (
              <div className="inpt-line__actions">
                <Button
                  onClick={() => store.removeMember(index)}
                  className="lnk lnk--red"
                >
                  Удалить
                </Button>
              </div>
            )}
          </div>
          <div className="inpt-line">
            <TextField
              value={member.position_ru}
              onChange={(value) => store.setMemberPositionRu(index, value)}
              placeholder="должность"
            />

            <TextField
              value={member.position_en}
              onChange={(value) => store.setMemberPositionEn(index, value)}
              placeholder="position"
            />
          </div>
        </div>
      ))}

      <div>
        <Button onClick={store.addMember}>+ сотрудник</Button>
      </div>
    </div>
  );
}
